import React, { useEffect, useState } from "react";
import Layout from "@/components/Layout";
import api from "@/lib/api";
import { Link } from "react-router-dom";
import { useAuth } from "@/lib/auth";
import { ArrowUpRight, Plus } from "lucide-react";

export default function MyCourses() {
  const { user } = useAuth();
  const [courses, setCourses] = useState([]);
  useEffect(() => { api.get("/courses").then(r => setCourses(r.data)).catch(() => {}); }, []);

  const isCreator = user?.role === "instructor" || user?.role === "org_admin" || user?.role === "super_admin";

  return (
    <Layout>
      <div className="px-10 py-10">
        <div className="flex items-end justify-between mb-10">
          <div>
            <div className="overline mb-2">Catalog</div>
            <h1 className="editorial-h1 text-5xl">Courses</h1>
          </div>
          {isCreator && <Link to="/builder/new" data-testid="courses-new" className="btn-primary"><Plus size={14}/> New</Link>}
        </div>

        {courses.length === 0 ? (
          <div className="editorial-card-static p-16 text-center">
            <div className="font-serif text-3xl mb-2">No courses yet.</div>
            <div className="text-[#52525B]">{isCreator ? "Create one to get started." : "Check the marketplace for public courses."}</div>
          </div>
        ) : (
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6">
            {courses.map(c => (
              <Link key={c.course_id} to={isCreator ? `/builder/${c.course_id}` : `/courses/${c.course_id}`} data-testid={`mycourse-${c.course_id}`} className="editorial-card block">
                <img src={c.thumbnail} className="w-full h-44 object-cover" alt="" />
                <div className="p-5">
                  <div className="flex items-center justify-between mb-2">
                    <div className="overline">{c.category}</div>
                    <div className={`overline ${c.is_published ? "text-[#166534]" : "text-[#854D0E]"}`}>{c.is_published ? "Published" : "Draft"}</div>
                  </div>
                  <div className="font-serif text-xl leading-tight mb-3">{c.title}</div>
                  <div className="flex items-center justify-between">
                    <span className="text-sm font-display">{c.price > 0 ? `$${c.price}` : "Free"} · {c.visibility}</span>
                    <ArrowUpRight size={14} strokeWidth={1.5}/>
                  </div>
                </div>
              </Link>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
}
